import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33cd8e92"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col flex-nowrap h-full mx-auto w-auto min-w-full"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Clear Filters")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Build Duration by Percentile ")
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col flex-nowrap h-full mx-auto w-auto min-w-full"
}

import { inject, ref, watch } from 'vue';
import { IncrediCard, IncrediButton } from 'incredi-ui';
import { IKPageSize } from '@/types/injectionKeys';
import { NetworkStatus } from '@apollo/client/core';
import dashboardNoData from '@/views/dashboard/components/dashboard-no-data.vue';
import totalWorkloadsChartController from '@/views/dashboard/views/DashboardWorkloads/components/charts/total-workloads-chart/total-workloads-chart-controller.vue';
import buildDurationPercentileList from '@/views/dashboard/views/DashboardWorkloads/components/charts/build-duration-percentile-list/build-duration-percentile-list.vue';
import buildDurationChartController from '@/views/dashboard/views/DashboardWorkloads/components/charts/build-duration-chart/build-duration-chart-controller.vue';
import workloadDurationByHoursChartController from '@/views/dashboard/views/DashboardWorkloads/components/charts/workload-duration-by-hours-chart/workload-duration-by-hours-chart-controller.vue';
import { useDashboardFilters } from '@/views/dashboard/components/dashboard-filter-bar/dashboard-filter.provider';
import { useDashboard, useFilteredDashboardMetadata } from '@/views/dashboard/dashboard.provider';
import DashboardChartTitle from '@/views/dashboard/components/dashboard-chart-title.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardWorkloads',
  setup(__props) {

const GQL_dashboardMetadataQuery = useFilteredDashboardMetadata({
  fetchPolicy: 'cache-and-network',
});

const size = inject(IKPageSize);
const dashboardFilters = useDashboardFilters();
const chartsKey = ref(0);

const dashboard = useDashboard();

if (dashboard.gql.workloadsQuery.networkStatus.value === NetworkStatus.ready) dashboard.gql.workloadsQuery.refetch();
else dashboard.gql.workloadsQuery.load();

const tooltipPercentile = [
  {
    description: ['The breakdown of builds by their duration.', 'For example, p75 is the duration of the build that was', 'the 75th percentile in terms of duration.'],
  },
];

watch(
  () => size?.value.width,
  newValue => {
    setTimeout(() => {
      if (newValue === size?.value.width) chartsKey.value += 1;
    }, 300);
  },
);

return (_ctx: any,_cache: any) => {
  return (_unref(GQL_dashboardMetadataQuery).networkStatus.value === _unref(NetworkStatus).ready && _unref(dashboard).gql.workloadsQuery.networkStatus.value === _unref(NetworkStatus).ready)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ((Object.values(_unref(dashboard).metadata.value.workloads.noData).every(s => s) && !_unref(dashboardFilters).isDirty.value) || !_unref(GQL_dashboardMetadataQuery).result.value?.dashboardMetadata?.hasWorkloads)
          ? (_openBlock(), _createBlock(dashboardNoData, {
              key: 0,
              icon: "no_data",
              "large-scale": "",
              title: _ctx.$t('dashboard.noData.title'),
              subtitle: _ctx.$t('dashboard.noData.subtitle')
            }, null, 8, ["title", "subtitle"]))
          : (Object.values(_unref(dashboard).metadata.value.workloads.noData).every(s => s) && _unref(dashboardFilters).isDirty.value)
            ? (_openBlock(), _createBlock(dashboardNoData, {
                key: 1,
                icon: "no_result_found",
                "large-scale": "",
                title: _ctx.$t('dashboard.noData.noResultsFound')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IncrediButton), {
                    design: "primary-green",
                    class: "px-[12px] py-[8px] !rounded-[50px] text-[13px] font-gordita-medium mt-[24px]",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(dashboardFilters).clearFilters()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["title"]))
            : (_openBlock(), _createElementBlock("div", {
                key: chartsKey.value,
                class: "dashboard-charts-grid-container mx-auto w-full max-w-[1624px]"
              }, [
                _createVNode(totalWorkloadsChartController, { class: "total-workloads" }),
                _createVNode(workloadDurationByHoursChartController, { class: "workload-duration-by-hours" }),
                _createVNode(_unref(IncrediCard), { class: "relative p-[16px] build-duration-percentile flex flex-col !shadow-none border border-Border/border_natural" }, {
                  default: _withCtx(() => [
                    _createVNode(DashboardChartTitle, {
                      absolute: "",
                      tooltip: tooltipPercentile
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(buildDurationPercentileList, { class: "mt-[31px]" })
                  ]),
                  _: 1
                }),
                _createVNode(buildDurationChartController, { class: "build-duration" })
              ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(dashboardNoData, {
          icon: "no_data",
          "large-scale": "",
          title: _ctx.$t('dashboard.noData.title'),
          subtitle: _ctx.$t('dashboard.noData.subtitle')
        }, null, 8, ["title", "subtitle"])
      ]))
}
}

})